var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearProtectiveClothing50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.56,22.944l3.38-2.139l-5.661-8.945c-0.738-1.165-2.001-1.86-3.38-1.86H27V9h-2v14h-2V9h-2v1 h-0.899c-1.378,0-2.642,0.695-3.38,1.861l-5.661,8.944l3.38,2.139L19,15.74v8.408l-3.902,13.535l4.805,1.385L23.381,27h1.238 l3.479,12.067l4.805-1.385L29,24.147V15.74L33.56,22.944z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearProtectiveClothing50);
export default __webpack_public_path__ + "static/media/icons8-wear-protective-clothing-50.657756e3f86069b525a97fbffe87e167.svg";
export { ForwardRef as ReactComponent };